export const environment = {
  production: true,
  defaultLocale: 'en',
  apiUrl: 'https://api.routeperfect.com/',
  frontUrl: 'https://www.routeperfect.com/',
  cdnUrl: 'https://cdn.routeperfect.com/',
  imgCdnUrl: 'https://cdn.routeperfect.com/app/images/',
  gtmApiKey: 'GTM-K2LD83',
  oLarkApiKey: '3655-876-10-2663',
  googleOptimizeId: 'GTM-KHWH6J2',
  googleAppId:
    '5139047547-8vih0l74boucg0jpfilkj3rplai0tf2u.apps.googleusercontent.com',
  googleApiKey: 'AIzaSyAu1opsd-mr62U6nmRy0WKlC5gIEcNmoxw',
  googleAnalyticsId: 'UA-34314721-1',
  facebookAppId: '410374335661154',
  pinterestAppId: '4934114165791926644',
  stretchTripEnabled: false,
  recaptchaKey: '6Lec774UAAAAAIYgJsOl15BTf4M3ZJPcNJhn3UUT',
  trustyouKey: '3e818501-0a35-48d6-a2a7-4c2ea36a9c28',
  cloudinaryName: 'djxk74uhg',
  cloudinaryApiKey: '8778722562s92249',
  cloudinaryApiSecret: 'd3PP3_hG0fE8fyp7GOEO5eDrAL8',
  tequilaApiUrl: 'https://api.tequila.kiwi.com/',
  tequilaApiKey: 'JQF4qRv-_E6ufN1dbzEx2bYVRVrZrJtA',
  radarSecretKey: 'prj_live_sk_bb9bfe68967aa80a4a43bf54e030942f9260aea6',
  radarLiveKey: 'prj_live_pk_aa9c0a8bc948035c320e6493488161ac0a24670d',
  mailiDirectUrl: 'https://direct-ux.meili.travel/index.js',
  mailiConnectUrl: 'https://connect-ux.meili.travel/index.js',
  mailiSearchUrl: 'https://search-ux.meili.travel/index.js',
  mailiBookingManagerUrl: 'https://booking-ux.meili.travel/index.js',
};
